@import "../../scss";

.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 2rem;
  background-color: var(--color-swamp-green);
  padding: var(--spacer-4);
  text-align: center;
}

.root:global(.enter) {
  opacity: 0;
}

.root:global(.enter-active) {
  transition: opacity 0.3s ease;
  opacity: 1;
}

.root:global(.exit) {
  opacity: 1;
}

.root:global(.exit-active) {
  transition: opacity 0.3s ease;
  opacity: 0;
}

:global {
  @keyframes grow {
    0% {
      transform: scale(1) rotate(0);
    }

    100% {
      transform: scale(1.2) rotate(3deg);
    }
  }
}

.image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  animation: grow 15s ease-out forwards;
}

.loader-wrapper {
  position: absolute;
  bottom: var(--spacer-15);
  margin: 0 auto;
  left: 0;
  right: 0;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @include media-breakpoint-down("md") {
    bottom: var(--spacer-10);
  }
}

.title {
  width: 45%;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -2.5%;
  transform: translate(-50%, -50%);

  @include media-breakpoint-down("md") {
    width: 90%;
  }
}

.loading-message {
  @include typo--loading-message();
  margin-top: var(--spacer-2);
  color: var(--color-cream);
}
